import { render, staticRenderFns } from "./returcustomer.vue?vue&type=template&id=3b7ddc21"
import script from "./returcustomer.vue?vue&type=script&lang=js"
export * from "./returcustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports